import React from "react";
import PropTypes from "prop-types";
import { Ellipsis } from "components/ui/Ellipsis";
import { BaseItemStyles } from "./BaseItemStyles";

export function BMailItem({ item }) {
  const { editor, summary, title, link } = item;

  return (
    <BaseItemStyles>
      <a href={link} target="_blank" rel="noopener noreferrer">
        <Ellipsis style={{ fontWeight: `bold` }}>{editor}</Ellipsis>
        <Ellipsis style={{ color: `var(--tundora)` }}>{title}</Ellipsis>
        <Ellipsis
          style={{
            fontSize: `var(--tiny-font-size)`,
            color: `var(--dusty-gray)`,
          }}
        >
          <i className="fa fa-envelope-o" /> {summary}
        </Ellipsis>
      </a>
    </BaseItemStyles>
  );
}

BMailItem.propTypes = {
  item: PropTypes.shape({
    editor: PropTypes.string,
    summary: PropTypes.string,
    title: PropTypes.string,
    link: PropTypes.string,
  }),
};
